const stepsRules = {
    ROAD_INTERNAL: {},
    ROAD_INTERNAL_PICKUP: {
        AIR_INTERNAL: {
            ROAD_INTERNAL_DELIVERY: {},
        },
        AIR_ROAD_INTERNAL: {},
        SEA_INTERNAL: {
            ROAD_INTERNAL_DELIVERY: {},
        },
        SEA_ROAD_INTERNAL: {},
    },
    SEA_ROAD_INTERNAL: {
        ROAD_INTERNAL_DELIVERY: {},
    },
    AIR_ROAD_INTERNAL: {
        ROAD_INTERNAL_DELIVERY: {},
    },
    ROAD_TO_EVENT: {
        EVENT_EVENT: {
            ROAD_FROM_EVENT: {},
        },
    },
}

export default stepsRules
